module.exports = __webpack_public_path__ + "static/media/cmulogo-500x500.7a0d2b4d.png";